import React, { PropsWithChildren } from 'react';

import { Box } from '@betterment/samba-react';

export const DetailRowValue: React.FC<PropsWithChildren> = ({ children }) => {
  return <Box css={{ display: 'flex', flexDirection: 'column', textAlign: 'right' }}>{children}</Box>;
};
